import {deepCopy} from "../util/util";
import _ from 'lodash'
import BaseStore from "./BaseStore"
/**
 * @description 剥离 BaseStore 中的扩展方法，方便在BaseStore 中进行注册，对BaseStore 进行重构
 * @date 2018/04/26
 * @author lei.you
 *
 * */
export default{

    /***
     *
     * @description :给状态拍照
     * @param{object} state 状态
     * @param{object} {key:''}  key  拍照指定的唯一名称
     *
     */
    shoot(state,data){
        // var key = data.key;
        // var copyState = deepCopy.deepcopy(state||this.state)
        // var stateMapping =BaseStore.getStateMapping(copyState[BaseStore.id]);
        // stateMapping[key]=copyState;
        // data.callbackData=copyState;
        //return copyState;
    },
    /***
     *
     * @description :清除所有的照片
     * @param{object} state 状态
     * @param{object} params {clearOrgin:true} 清除所有照片是否包括最初状态照片，默认是不清除
     *
     */
    removeAllPhotograph(state,params={clearOrgin:false}){
        //BaseStore.mapping[]
        var stateMapping =BaseStore.getStateMapping(state[BaseStore.id]);
        for(var key in stateMapping){
            if(params.clearOrgin){
                stateMapping[key]={};
            }else{
                if(key!=BaseStore.STATE_INIT){
                    stateMapping[key]={};
                }
            }
        }
    },
    /***
     *
     * @description :清除指定名称的照片
     * @param{object} state 状态
     * @param{object} {key:''}  key  照片名称
     *
     */
    removePhotographByName(state,data){
        var stateMapping =BaseStore.getStateMapping(state[BaseStore.id]);
        stateMapping[data.key]={};

    },
    /***
     *
     * @description :还原到某一个指定名称的状态
     * @param{object} state 状态
     * @param{object} {callbackData:{}}  返回给用户的数据
     *
     */
    restore(state,data){
        var key =data.key;
        var stateMapping = BaseStore.getStateMapping(state[BaseStore.id]);
        var copyState = deepCopy.deepcopy(stateMapping[key]);
        var result = _.assign(state,copyState);
        data.callbackData=result;
    },
    /***
     *
     * @description :清除状态设置，恢复最初状态
     * @param{object} state 状态
     * @param{object} {key:''}  key  拍照指定的唯一名称
     * 增加处理
     */


    reset(state){
        //console.log(state.id)
        //this.state=BaseStore.copyState;
        var stateMapping = BaseStore.getStateMapping(state[BaseStore.id]);
        _.assign(state,stateMapping[BaseStore.STATE_INIT]);
    },

    /**
     * @description 打印当前store的快照数据供调试使用
     * @return {object} 返回当前store的快照数据供调试使用
     * */
    console(state){

        var stateMapping =BaseStore.getStateMapping(state[BaseStore.id]);
        console.log(stateMapping);
        return stateMapping;
    }

}
